import { onDestroyEffect } from "svelte-toolbelt";
import { BROWSER } from "esm-env";
const defaultOpts = {
    immediate: true,
};
export class TimeoutFn {
    #opts;
    #interval;
    #cb;
    #timer = null;
    constructor(cb, interval, opts = {}) {
        this.#cb = cb;
        this.#interval = interval;
        this.#opts = { ...defaultOpts, ...opts };
        this.stop = this.stop.bind(this);
        this.start = this.start.bind(this);
        if (this.#opts.immediate && BROWSER) {
            this.start();
        }
        onDestroyEffect(this.stop);
    }
    #clear() {
        if (this.#timer !== null) {
            window.clearTimeout(this.#timer);
            this.#timer = null;
        }
    }
    stop() {
        this.#clear();
    }
    start(...args) {
        this.#clear();
        this.#timer = window.setTimeout(() => {
            this.#timer = null;
            this.#cb(...args);
        }, this.#interval);
    }
}
